<template>
  <button class="button" :type="type" v-if="!linksTo">
    <template v-if="!isLoading">
      <i class="text-xl mr-1" :class="beforeIconClass" v-if="beforeIconClass" />
      <slot />
    </template>

    <span v-else>
      <i class="fal fa-sun fa-spin" />
    </span>
  </button>

  <router-link class="button" tag="button" :to="linksTo" v-else>
    <i
      class="text-white text-xl pr-1"
      :class="beforeIconClass"
      v-if="beforeIconClass"
    />
    <slot />
  </router-link>
</template>

<script>
export default {
  name: "BdgButton",
  props: {
    beforeIconClass: String,
    linksTo: [String, Object],
    isLoading: Boolean,
    type: String
  }
};
</script>

<style lang="scss" scoped></style>
